// Maps character name surface-forms found in verse text -> character card id.
// Curated to avoid ambiguous false positives (e.g. plain "Mary", "John", "James").
const ALIASES = {
  Adam: "adam", Eve: "eve", Cain: "cain", Abel: "abel", Noah: "noah",
  Abraham: "abraham", Abram: "abraham", Sarah: "sarah", Hagar: "hagar",
  Isaac: "isaac", Rebekah: "rebekah", Jacob: "jacob", Esau: "esau",
  Rachel: "rachel", Leah: "leah", Judah: "judah",
  Moses: "moses", Aaron: "aaron", Miriam: "miriam", Pharaoh: "pharaoh",
  Joshua: "joshua", Caleb: "caleb", Rahab: "rahab", Deborah: "deborah",
  Gideon: "gideon", Samson: "samson", Delilah: "delilah",
  Ruth: "ruth", Naomi: "naomi", Boaz: "boaz", Samuel: "samuel", Saul: "saul",
  David: "david", Goliath: "goliath", Jonathan: "jonathan", Bathsheba: "bathsheba",
  Solomon: "solomon", Rehoboam: "rehoboam", Elijah: "elijah", Elisha: "elisha",
  Ahab: "ahab", Jezebel: "jezebel", Naaman: "naaman", Hezekiah: "hezekiah",
  Josiah: "josiah", Isaiah: "isaiah", Jeremiah: "jeremiah", Ezekiel: "ezekiel",
  Daniel: "daniel", Shadrach: "shadrach", Meshach: "meshach", Abednego: "abednego",
  Nebuchadnezzar: "nebuchadnezzar", Ezra: "ezra", Nehemiah: "nehemiah",
  Esther: "esther", Mordecai: "mordecai", Job: "job", Jonah: "jonah",
  Hosea: "hosea", Amos: "amos", Melchizedek: "melchizedek", Enoch: "enoch",
  Lot: "lot", Balaam: "balaam", Nathan: "nathan", Absalom: "absalom",
  Jesus: "jesus",
  "Pontius Pilate": "pilate", Pilate: "pilate",
  Nicodemus: "nicodemus", Zacchaeus: "zacchaeus", Lazarus: "lazarus", Martha: "martha",
  Peter: "peter", Andrew: "andrew", Thomas: "thomas", Matthew: "matthew",
  Bartholomew: "bartholomew", Nathanael: "bartholomew", Matthias: "matthias",
  Barnabas: "barnabas", Timothy: "timothy", Titus: "titus", Silas: "silas",
  Priscilla: "priscilla", Aquila: "aquila", Lydia: "lydia", Cornelius: "cornelius",
  Apollos: "apollos", Philemon: "philemon", Onesimus: "onesimus", Stephen: "stephen",
  Paul: "paul", Luke: "luke",
  "Judas Iscariot": "judas-iscariot", "Mary Magdalene": "mary-magdalene",
};

const escape = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
const KEYS = Object.keys(ALIASES).sort((a, b) => b.length - a.length);
const RE = new RegExp(`\\b(${KEYS.map(escape).join("|")})\\b`, "g");

export const characterIdFor = (name) => ALIASES[name] || null;

// Splits verse text into plain strings + {token, cid} match markers.
// Returns an array consumable by a renderer.
export function tokenizeCharacters(text) {
  const out = [];
  let last = 0;
  let m;
  RE.lastIndex = 0;
  while ((m = RE.exec(text)) !== null) {
    if (m.index > last) out.push(text.slice(last, m.index));
    out.push({ token: m[0], cid: ALIASES[m[0]] });
    last = m.index + m[0].length;
  }
  if (last < text.length) out.push(text.slice(last));
  return out;
}
